// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"5a74f190","408":"e231ce50","424":"71ae46a4"}[chunkId] + ".chunk.js";
};